/**
 * Igbo.
 *
 * First pass. Awaiting review by a native speaker with clinical vocabulary —
 * `reviewed: false` is deliberate and should gate any clinical release.
 *
 * Written in Standard Igbo with tone marks left off except where they are
 * routinely written, which is what most Igbo readers actually encounter in
 * print. A reviewer may reasonably want them restored throughout; that is a
 * decision for a speaker, not for me.
 *
 * "Ọkpụkpọ obi" (the knocking of the heart) is preferred to a borrowed term for
 * pulse, and "nyocha" is used for a reading — the everyday word, because this
 * screen is read by people deciding whether to trust us.
 */

export default {
  code: 'ig',
  intl: 'ig-NG',
  name: 'Igbo',
  endonym: 'Igbo',
  reviewed: false,
  strings: {
    'app.tagline': 'Ọ na-agụ ọkpụkpọ obi gị site na igwefoto — ma na-ekwu eziokwu mgbe ọ na-apụghị ịhụ gị.',
    'app.disclaimer': 'Ihe nnwale na-arụ ọrụ. Ọ bụghị ngwaọrụ ahụike, e nyochabeghị ya, ọ bụghịkwa nchọpụta ọrịa.',
    'app.skip': 'Wụga n’isi ọdịnaya',
    'app.language': 'Asụsụ',
    'app.install': 'Tinye Ori na ngwaọrụ a',
    'app.update.title': 'Ụdị ọhụrụ nke Ori adịla njikere',
    'app.update.body':
      'A ga-eji ya mgbe ọzọ ị meghere ngwa a, ma ọ bụ ị nwere ike ịgbanwe ugbu a. Ọ dịghị ihe ị chekwara nke ọ ga-emetụta.',
    'app.update.action': 'Melite ugbu a',
    'app.queued': 'Nyocha {count} na-eche izipu',
    'app.queued.one': 'Nyocha 1 na-eche izipu',

    'nav.start': 'Gịnị bụ nke a',
    'nav.scan': 'Mee nyocha',
    'nav.ori': 'Ori gị',
    'nav.record': 'Ndekọ gị',
    'nav.consent': 'Ihe ị na-ekere',
    'nav.care': 'Ebe ị ga-aga',
    'nav.pledge': 'Nkwa Akpụkpọ Ahụ',

    'status.deviceKey': 'E debere ndekọ na ngwaọrụ a',
    'status.noKey': 'Enweghị igodo ngwaọrụ',
    'status.preparingKey': 'A na-akwadebe igodo ngwaọrụ…',
    'status.corpusLive': 'Nchịkọta nyocha · na-arụ ọrụ',
    'status.corpusOffline': 'Nchịkọta nyocha · enweghị njikọ',
    'status.corpusUnset': 'Ahazibeghị nchịkọta nyocha',
    'status.sharing': 'Na-ekere nyocha',
    'status.notSharing': 'Anaghị ekere',

    'start.eyebrow': 'OmniAlera Ori',
    'start.title.line1': 'Ọkpụkpọ obi gị,',
    'start.title.line2': 'nke ìhè na-agụ',
    'start.plain1': 'Obi gị na-akwaga ọbara n’ihu gị. Nkwaga ọ bụla na-eme ka akpụkpọ ahụ gị chaa ntakịrị uhie.',
    'start.plain2': 'Ọ dị obere nke ukwuu nke anya gị apụghị ịhụ. Mana igwefoto pụrụ ịhụ ya.',
    'start.plain3': 'Ya mere ị na-ele igwefoto anya sekọnd ole na ole, Ori ana-agụkwa ọkpụkpọ obi gị.',
    'start.plain3b': 'Enweghị elekere. Enweghị eriri. Enweghị ihe ị ga-azụ.',
    'start.problem': 'Nsogbu ahụ bụ nke a',
    'start.step1.lead': 'Akpụkpọ ahụ nwere agba.',
    'start.step1.body': 'Akpụkpọ ahụ gbara ọchịchịrị na-ekpochapụ ìhè ndị ọzọ igwefoto na-achọ, ya mere mgbaàmà na-adị ntakịrị.',
    'start.step2.lead': 'Ọtụtụ ngwa anaghị elebara nke a anya.',
    'start.step2.body': 'Ha na-egosi gị ọnụọgụ n’agbanyeghị. Ọ nwere ike ịbụ nnukwu njehie ma na-adị ka ihe doro anya kpamkpam.',
    'start.step3.lead': 'Ori anaghị akọ nkọ.',
    'start.step3.body': 'Ọ bụrụ na ọ pụghị ịhụ ọkpụkpọ obi gị nke ọma, ọ na-agwa gị. Nke ahụ bụ ndịiche niile.',
    'start.step4.lead': 'Ị nwere ike inye aka idozi ya.',
    'start.step4.body': 'Nyocha ọ bụla ị họrọ ikere — ọbụna nke dara — na-akụziri ụdị na-abịa ịhụ akpụkpọ ahụ dị ka nke gị. A na-akwụ gị ụgwọ, ị nwekwara ike iweghachi ya n’oge ọ bụla.',
    'start.before.title': 'Tupu nyocha mbụ gị',
    'start.before.body': 'Họrọ akụkụ kacha yie akpụkpọ ahụ gị. Ọtụtụ ngwa ahụike anaghị ajụ ma ọlị. Ọ bụ otu ihe na-ekpebi ma atụmatụ ahụ ọ ga-arụ ọrụ ma ọlị.',
    'start.pledge.title': 'Kwee Nkwa Akpụkpọ Ahụ',
    'start.pledge.body': 'Kwe ka nyocha ọ bụla — na-enweghị ihe ọ bụla na-akọwa onye ị bụ — sonye na nchịkọta data mepere emepe nke na-akụziri ụdị ndị a ịhụ akpụkpọ ahụ gbara ọchịchịrị. Ị nwere ike ile ka ọnụọgụ na-arị elu, gbanyụọkwa nke a mgbe ọ bụla ị chọrọ.',
    'start.pledge.earn': 'Ọ na-enweta kredit 25 maka nyocha ọ bụla',
    'start.cta.ready': 'Mee nyocha mbụ m',
    'start.cta.needTone': 'Buru ụzọ họrọ agba',
    'start.cta.counter': 'Buru ụzọ hụ ọnụọgụ ahụ',
    'tone.lightest': 'Kacha acha ọcha',
    'tone.darkest': 'Kacha gbaa ọchịchịrị',
    'tone.chosen': 'Agba {n} n’ime 10',
    'tone.none': 'Ahọrọbeghị',
    'tone.label': 'Agba akpụkpọ ahụ {n} n’ime 10',
    'tone.group': 'Agba akpụkpọ ahụ gị',

    'scan.eyebrow': 'Mee nyocha',
    'scan.title.idle': 'Nọrọ jụụ ma lee igwefoto anya',
    'scan.title.running': 'A na-agụ gị ugbu a — nọrọ jụụ',
    'scan.title.locked': 'Anwetala ya',
    'scan.title.failed': 'Ori enweghị ike ịgụ gị',
    'scan.intro':
      'Ori na-ele akụkụ atọ nke ihu gị n’otu oge — egedege ihu na nti abụọ — ọ na-agụkwa nke ọ bụla n’ụzọ abụọ dị iche. Ọ na-enye gị ọnụọgụ naanị mgbe ha niile kwekọrọ.',
    'scan.start': 'Malite',
    'scan.running': 'Na-agụ…',
    'scan.again': 'Nyochaa ọzọ',
    'scan.useCamera': 'Jiri igwefoto m',
    'scan.useSimulated': 'Laghachi na nnwale',
    'scan.privacy':
      'Igwefoto ozugbo, n’ezigbo oge. Ọ dịghị ihe ị na-ahụ na-apụ na ngwaọrụ a — a na-eme atụmatụ ahụ n’ime ihe nchọgharị gị, e bugobeghịkwa foto ọ bụla elu.',
    'scan.simulated':
      'Nnwale n’agba akpụkpọ ahụ {tone}, e mepụtara ya ugboro anọ ngwa karịa ezigbo oge ka ị ghara ichere. Ihe dịka pasent {attenuation} nke mgbaàmà ọkpụkpọ obi na-adị ndụ n’agba a.',
    'scan.skipped': 'A gafere foto {count} — Ori kwadoro ichere karịa ịkọ nkọ.',
    'scan.skipped.one': 'A gafere foto 1 — Ori kwadoro ichere karịa ịkọ nkọ.',
    'scan.guess': 'Nkọ kacha mma ugbu a: {bpm} bpm — a tụkwasibeghị ya obi.',
    'scan.guess.disagree': 'Ụzọ abụọ ahụ ekwekọghị, ya mere Ori ka na-achọ.',
    'scan.guess.settling': 'A na-echere ka ọ kwụsie ike.',

    'stat.elapsed': 'Oge',
    'stat.clarity': 'Ìhè',
    'stat.agreement': 'Nkwekọ akụkụ',
    'stat.pulse': 'Ọkpụkpọ obi',
    'stat.breathing': 'Iku ume',
    'stat.variability': 'Ndịiche',
    'unit.bpm': 'bpm',
    'unit.perMin': '/nkeji',
    'unit.ms': 'ms',
    'unit.s': 'sek',

    'advice.ok': 'Ọ dị mma — nọrọ jụụ.',
    'advice.no_face': 'Ahụghị ihu — bịa n’etiti.',
    'advice.too_dark': 'Ọchịchịrị adịla ukwuu. Chee ihu na windo ma ọ bụ oriọna.',
    'advice.dim': 'Ọ gbara ntakịrị ọchịchịrị — ìhè ndị ọzọ ga-eme ka ọ dị ngwa.',
    'advice.clipped': 'Ìhè adịla ukwuu — tụgharịa site n’ìhè ahụ.',
    'advice.bright': 'Ìhè dị ukwuu. Nwaa ịtụgharị ntakịrị.',
    'advice.motion': 'Mmegharị adịla ukwuu — nọrọ jụụ.',
    'advice.slight_motion': 'Gbalịa ịnọ jụụ.',

    'card.share': 'Kesaa nyocha a',
    'card.sharing': 'Na-akwadebe…',
    'card.downloaded': 'Echekwara ya na ngwaọrụ gị.',
    'card.failed': 'Enweghị ike ime kaadị ahụ na ngwaọrụ a.',
    'card.pulse': 'Ọkpụkpọ obi',
    'card.breathing': 'Iku ume',
    'card.variability': 'Ndịiche',
    'card.time': 'Oge o were',
    'card.regions': 'Akụkụ kwekọrọ',
    'card.methods': 'Ndịiche ụzọ',
    'card.tone': 'Agba akpụkpọ ahụ',
    'card.trusted': 'E kwadoro ya site n’akụkụ atọ na ụzọ abụọ',
    'card.honest': 'Ori kwuru ya kama ịkọ nkọ',
    'card.refusedLabel': 'Enweghị nyocha',
    'card.refusedHeadline': 'Ori apụghị ịhụ m nke ọma.',
    'card.lockedBody': 'E ji ìhè si n’akpụkpọ ahụ m laghachi tụọ ya — enweghị elekere, enweghị eriri, ọ dịghị ihe metụrụ m aka. Ori na-akọ ọnụọgụ naanị mgbe akụkụ nwere onwe ha na ụzọ nwere onwe ha kwekọrọ.',
    'card.refusedBody': 'Kama ibipụta ọnụọgụ ezighi ezi n’obi ike, Ori jụrụ — dekọọkwa njụ ahụ, ka e nwee ike ịtụle mmejọ ahụ ma dozie ya kama ka ọ na-eme onwe ya na nzuzo.',
    'card.disclaimer': 'Ihe nnwale. Ọ bụghị ngwaọrụ ahụike. Ọ bụghị nchọpụta ọrịa.',

    'canvas.traceEmpty': 'ìhè na-alaghachi site n’akpụkpọ ahụ gị',
    'canvas.signalReaches': 'pasent {percent} nke mgbaàmà ọkpụkpọ obi na-eru igwefoto',
    'canvas.noReading': 'enweghị nyocha ugbu a',
    'canvas.steady': '{bpm} bpm · kwụsiri ike',
    'canvas.couldNotRead': 'ọ pụghị ịgụ gị',

    'result.title': 'Nyocha gị',
    'result.found': 'achọtara ya n’ime sekọnd {seconds}',
    'result.none': 'enweghị mgbaàmà doro anya',
    'result.confirmed':
      'E kwadoro ya site na nyocha akụkụ {regions} na ụzọ nwere onwe ha {methods}, ndị kwekọrọ n’ime {spread} bpm.',
    'result.refused':
      'Ori lere anya ruo oge niile ma ọ hụghị ọkpụkpọ obi ọ tụkwasịrị obi. N’agba akpụkpọ ahụ a, ihe dịka pasent {attenuation} nke mgbaàmà ọkpụkpọ obi na-alaghachikwute igwefoto. Kama inye gị ọnụọgụ ọ na-apụghị iguzo n’azụ ya, Ori na-agwa gị na ọ pụghị ịhụ gị.',
    'result.conventional': 'Ngwa ọdịnala gaara akọ {bpm} bpm site n’otu data ahụ',
    'result.conventional.locked': '.',
    'result.conventional.failed': ', n’enweghị ịdọ aka ná ntị ọ bụla. Nke ahụ bụ ihe a na-ere taa.',

    'diag.toggle': 'Ihe Ori na-ahụ',
    'diag.empty': 'Ọ dịghị ihe ugbu a. Ori chọrọ ihe dịka sekọnd asatọ nke vidiyo dị mma tupu o nwee ihe ọ ga-egosi.',
    'diag.method': 'Ụzọ',
    'diag.reads': 'Ọ gụrụ',
    'diag.from': 'Site na',
    'diag.method.pos': 'Agba (POS)',
    'diag.method.green': 'Ọwa akwụkwọ ndụ',
    'diag.regions': 'Akụkụ {count}',
    'diag.regions.one': 'Akụkụ 1',
    'diag.disagree':
      'Ụzọ abụọ ahụ dị iche site na {spread} bpm. Ikekwe otu n’ime ha na-eso mmegharị kama ọkpụkpọ obi, ya mere Ori agaghị akọ nke ọ bụla.',
    'diag.agree': 'Ụzọ abụọ ahụ kwekọrọ n’ime {spread} bpm.',
    'diag.framesUsed': 'Foto e jiri mee ihe',
    'diag.harmonic': 'Nkwado harmonic',
    'diag.spread': 'Ndịiche n’etiti akụkụ',
    'diag.perfusion': 'Mgbasa ọbara',

    'consent.eyebrow': 'Ihe ị na-ekere',
    'consent.title.lead': 'Mgbanwe anọ.',
    'consent.title.em': 'Ha niile gbanyụrụ ruo mgbe i kwuru.',
    'consent.lede': 'Enwere ike ịgbanyụ nke ọ bụla n’enweghị ntufu ndekọ gị, nke ọ bụla na-akwụkwa gị ụgwọ mgbe ọ gbanyere.',
    'consent.offline.title': 'Enweghị njikọ',
    'consent.offline.body': 'A pụghị iru ọrụ Ori, ya mere enweghị ike ịgbanwe mgbanwe ndị a ugbu a. Ndekọ gị dị nchebe na ngwaọrụ a, a naghịkwa ekere ihe ọ bụla mgbe ị nọ na-enweghị njikọ.',
    'consent.error.title': 'Ọ chekwaghị',
    'consent.corpus.title': 'Nyere aka idozi ụdị ahụ',
    'consent.corpus.body': 'Nyocha ọ bụla, na-enweghị ihe ọ bụla na-akọwa onye ị bụ, na-esonye na nchịkọta data mepere emepe nke na-akụziri ụdị ndị a ịhụ akpụkpọ ahụ gbara ọchịchịrị. Nyocha ndị dara bụ nke kacha baa uru n’ime ha niile.',
    'consent.corpus.earn': 'Kredit 25 maka nyocha ọ bụla',
    'consent.routing.title': 'Tụọ aro ebe m ga-aga',
    'consent.routing.body': 'Kwe ka Ori gosi gị ikpo okwu OmniAlera kwesịrị ekwesị mgbe nyocha kwadoro ya. A naghị ezipu ihe ọ bụla ebe ọ bụla — a na-eme ntụaro ahụ na ngwaọrụ nke gị.',
    'consent.routing.earn': 'N’efu, ọ dịghịkwa data na-apụ',
    'consent.cohort.title': 'Sonye n’otu nyocha',
    'consent.cohort.body': 'Bụrụ akụkụ nke otu ogologo oge nke a na-amaghị aha ndị nọ na ya, nke ndị mmekọ nyocha a nyochara nwere ike ịmụ. Pụọ mgbe ọ bụla ị chọrọ: ịpụ na-ewepụ gị na mmịpụta ọ bụla nke ọdịnihu, a na-agwakwa ndị mmekọ ji mmịpụta gara aga.',
    'consent.cohort.earn': 'Kredit 10 ọzọ maka nyocha ọ bụla',
    'consent.assistant.title': 'Kwe ka Ori gụọ ndekọ m',
    'consent.assistant.body': 'Kwe ka nchịkọta nyocha gị soro ajụjụ gaa ka Ori wee zaa gbasara omume nke gị. A naghị etinye onye ị bụ na ya ma ọlị.',
    'consent.assistant.earn': 'N’efu',
    'consent.earned.title': 'Ihe ị nwetara',
    'consent.earned.value': 'Kredit {credits}',
    'consent.earned.body': 'Ọnụego ihe atụ. N’ezie ọrụ, a ga-akwụ ha site na ego ekwentị. Isi ihe bụ na a na-akwụ ụgwọ maka inye aka, ọ bụghị onyinye nye ụlọ ọrụ ga-erekwa ya ọzọ.',
    'consent.withdraw.title': 'Otú iweghachi si arụ ọrụ n’ezie',
    'consent.withdraw.body1': 'Ịgbanyụ otu nyocha na-eme ihe atọ, ọ bụghị otu. A na-ewepụ gị na mmịpụta ọ bụla e wuru site ugbu a gaa n’ihu. Mmịpụta ọ bụla e wuruworo mana anataghị ya ka na-ewepụ ahịrị gị tupu e nyefee ya. Maka mmịpụta e nyefeworo, a na-enye onye mmekọ ji ha ọkwa na-akpọ gị dị ka onye weghachiri.',
    'consent.withdraw.body2': 'Nke atọ ahụ bụ akụkụ ihe fọrọ nke nta ka ọ bụrụ na ọ dịghị onye na-ewu. Nkwenye nke na-apụghị iru data si n’ụlọ pụọ abụghị nkwenye — ọ bụ akwụkwọ efu.',

    'shared.why': 'Ihe kpatara nke a',
    'shared.kept': 'E debere ya na ngwaọrụ a. Ikere agbanyụọla.',
    'shared.keptNoService': 'E debere ya na ngwaọrụ a — ahazighị ọrụ nchịkọta ọ bụla.',
    'shared.sending': 'Na-ekere…',
    'shared.added': 'Etinyela ya na nchịkọta.',
    'shared.addedWithQueue': 'Etinyela ya na nchịkọta, tinyere nyocha {count} nke nọ na-eche.',
    'shared.queuedOffline':
      'E debere ya na ngwaọrụ a. A ga-ekere ya ozugbo ị laghachiri n’ịntanetị ({count} na-eche).',
    'shared.refused': 'Ọrụ ahụ anabataghị nyocha a, ya mere e keghị ihe ọ bụla.',
    'shared.flushed': 'Nyocha {count} nke nọ na-eche adịla ugbu a na nchịkọta.',
    'shared.flushed.one': 'Nyocha 1 nke nọ na-eche adịla ugbu a na nchịkọta.',

    /* ── echiche abụọ ───────────────────────────────────────────────── */
    'view.group': 'Onye a na-atụrụ maka ya',
    'view.patient': 'Maka m',
    'view.clinician': 'Maka dọkịta',

    'floor.empty': 'Ọ dịghị ihe a ga-ese ugbu a.',
    'floor.bar': 'ihe ọ ga-agafe',
    'floor.axis': 'ọnụọgụ nwere ike ịbụ',
    'floor.alt': 'Ọnụọgụ niile Ori lere anya, na ọkwa nke ọ ga-eru tupu Ori ekwuo ya.',
    'floor.caption.locked':
      'Akara ogologo ahụ bụ ka obi gị si akụ. Ọ gafere ahịrị ntụpọ ahụ nke ọma — ahịrị ahụ bụ ọkwa Ori chọrọ tupu ọ kwuo ihe ọ bụla.',
    'floor.caption.refused':
      'Ọ dịghị ihe rutere ahịrị ntụpọ ahụ ebe a. Ahịrị ahụ bụ ọkwa Ori chọrọ tupu ọ gwa gị ọnụọgụ — ya mere ọ gwaghị.',

    'clin.locked': 'Kpọchiri na {bpm} bpm mgbe sekọnd {seconds} gasịrị. Ihe ise niile zuru okè.',
    'clin.refused': 'Ọ dịghị atụ. Ọ dara na: {gates}.',
    'clin.refusedNoGate':
      'Ọ dịghị atụ. Oge ahụ mechiri tupu nyocha ọ bụla zuo ihe ise niile.',
    'clin.region': 'Mpaghara',
    'clin.region.forehead': 'Egedege ihu',
    'clin.region.leftCheek': 'Nti aka ekpe',
    'clin.region.rightCheek': 'Nti aka nri',
    'clin.region.other': 'Mpaghara {n}',
    'clin.attenuation': 'Akara rutere ngwaọrụ',
    'clin.engine': 'Ngwa nyocha',
    'clin.conventional':
      'Ngwa atụ nkịtị gaara akọ {bpm} bpm site na otu ndekọ a.',
    'clin.disclaimer':
      'Ihe nnwale na-arụ ọrụ. Ọ bụghị ngwaọrụ ahụike, e jiribeghị ya tụnyere ezigbo ngwaọrụ atụ, ọ bụghịkwa ntọala maka mkpebi ahụike ọ bụla.',

    'gate.header.criterion': 'Ihe achọrọ',
    'gate.header.measured': 'Ihe atụrụ',
    'gate.header.required': 'Ihe achọrọ',
    'gate.prominence': 'Ogologo akara',
    'gate.harmonic': 'Nkwado nkụda nke abụọ',
    'gate.stability': 'Nkwụsi ike',
    'gate.agreement': 'Nkwekọrịta mpaghara',
    'gate.methods': 'Ọdịiche ụzọ',
    'gate.pass': 'gafere',
    'gate.fail': 'dara',
    'gate.skip': 'a nyochaghị ya',
    'gate.notAssessed': 'enweghị ike inyocha — mpaghara {regions} ka a ga-eji rụọ ọrụ',


    /* ── ihe ị ga-atụ anya na ụcha akpụkpọ ahụ ị họrọ ────────────────── */
    'tone.expect.strong':
      'Na ụcha akpụkpọ ahụ a, akara ahụ siri ike. Ori ga-enwe ike ịgụ gị n\'ọtụtụ oge.',
    'tone.expect.good':
      'Na ụcha akpụkpọ ahụ a, akara ahụ dị mma. Ori ga-enwekarị ike ịgụ gị.',
    'tone.expect.weak':
      'Na ụcha akpụkpọ ahụ a, akara ahụ adịghị ike. Ori agaghị enwe ike ịgụ gị ọtụtụ mgbe — mgbe nke ahụ mere, ọ ga-agwa gị, kama inye gị ọnụọgụ ọ na-apụghị ịkwado.',
    'tone.expect.veryWeak':
      'Na ụcha akpụkpọ ahụ a, akara ahụ adịghị ike ma ọlị, Ori agaghịkwa enwe ike ịgụ gị ọtụtụ mgbe. Nke ahụ bụ ezi oke nke ihe igwefoto pụrụ ịhụ taa. Ịjụ ọ bụla ị kesara bụ ihe na-agbanwe ya.',

    'shared.notKept':
      'Enweghị ike ịchekwa atụ a na ngwaọrụ gị. O nweghị ihe e kesara, atụ ahụ apụọkwala — nke a na-abụkarị ọchịchọ nzuzo ma ọ bụ ebe nchekwa juru.',

  },
};
